import {
  Caption,
  ConfirmBookingButton,
  CreateShiftCardsWrapper,
  ConfirmButtonWrapper,
  Heading,
  IconWithMarginRight,
} from 'pages/CreateShiftsPage/BulkCreateShiftView/BulkCreateShiftView.styled';
import { SelectDatesButton } from './SelectDatesButton';
import { CreateShiftCard } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard';
import { ICreateShift } from 'pages/CreateShiftsPage/CreateShiftsPage.types';
import { useCreateShiftsPageContext } from 'pages/CreateShiftsPage/CreateShiftsPage.context';
import { getInitialCreateShiftForm } from 'pages/CreateShiftsPage/CreateShiftsPage.utils';
import { MountTransition } from 'routes/MountTransition';
import { CreateShiftCardProvider } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftCard/CreateShiftCard.context';
import { FC, Fragment } from 'react';
import { BKJButton } from '@awais4123/fillify-design-library';
import { Flex } from 'components/Flex';
import { useTranslation } from 'react-i18next';

export const WebBulkCreateShiftView: FC = () => {
  const { groupedFormsBehaviors, onConfirmBooking } = useCreateShiftsPageContext();
  const {
    addFormItem,
    groupedForms,
    isSubmitDisabled,
    groupedFormsFieldErrors,
    groupedFormsFormErrors,
  } = groupedFormsBehaviors;

  const createShifts = groupedForms as ICreateShift[];

  const addBlankShift = () => {
    addFormItem(getInitialCreateShiftForm({}));
  };

  const { t } = useTranslation();

  return (
    <Fragment>
      <Heading data-cy="hdr-selectDates">
        {t('create_shifts:SELECT_DATES')}
        <Caption data-cy="hdr-caption">{t('create_shifts:SELECT_DATES_INFO')}</Caption>
      </Heading>
      <SelectDatesButton>{t('create_shifts:SELECT_DATES')}</SelectDatesButton>
      <CreateShiftCardsWrapper>
        {createShifts.map((createShift, index) => (
          <MountTransition key={createShift.values.id}>
            <CreateShiftCardProvider
              key={createShift.values.id}
              createShift={createShift}
              fieldErrors={groupedFormsFieldErrors[index]}
              formErrors={groupedFormsFormErrors[index]}
            >
              <CreateShiftCard />
            </CreateShiftCardProvider>
          </MountTransition>
        ))}
      </CreateShiftCardsWrapper>
      <Flex width="100%">
        <BKJButton
          variant="PurpleNoDecorations"
          onClick={addBlankShift}
          minWidth="fit-content"
          width="fit-content"
          data-cy="btn-addAnothrShift"
        >
          <IconWithMarginRight iconName="Add" />
          {t('create_shifts:ADD_ANOTHER_SHIFT')}
        </BKJButton>
      </Flex>
      <ConfirmButtonWrapper>
        <ConfirmBookingButton
          variant="GreenSolid"
          onClick={onConfirmBooking}
          isSubmitDisabled={isSubmitDisabled}
          data-cy="btn-confirmBooking"
        >
          {t('create_shifts:CONFIRM_BOOKING')}
        </ConfirmBookingButton>
      </ConfirmButtonWrapper>
    </Fragment>
  );
};
